import {
	POST_LOGIN_BEGIN,
	POST_LOGIN_ERROR,
	POST_LOGIN_RESET,
	POST_LOGIN_SUCCESS,
	CLEAR_MUST_CHANGE,
} from "../actions/navActions"
import { authStorage } from "../../utilities/Auth"

const initialState = {
	modalOpen: false,
	depPaid: true,
	logged: true,
	user: "Boss",
	token: "",
	shouldDisconnect: false,
	login: {
		username: authStorage.getUser() ?? "",
		userId: parseInt(authStorage.getUserId()) ?? 0,
		token: authStorage.getToken() ?? "",
		groups: authStorage.getGroups() ?? [],
		employeId: parseInt(authStorage.getEmployeId()) ?? 0,
		mustChangePassword: authStorage.getMustChangePassword(),
	},
	postLogin: {
		loading: false,
		loaded: false,
		error: false,
	},
}

function setNav(state = initialState, action) {
	let nextState
	switch (action.type) {
		case POST_LOGIN_BEGIN:
			return {
				...state,
				login: {
					username: "",
					userId: 0,
					token: "",
					groups: [],
					employeId: 0,
					mustChangePassword: false,
				},
				postLogin: {
					loading: true,
					loaded: false,
					error: false,
				},
			}
		case POST_LOGIN_RESET:
			authStorage.setUser("")
			authStorage.setToken("")
			authStorage.setGroups([])
			authStorage.setEmployeId(0)
			authStorage.setUserId(0)
			authStorage.setMustChangePassword(false)
			return {
				...state,
				login: {
					username: "",
					userId: 0,
					token: "",
					groups: [],
					employeId: 0,
					mustChangePassword: false,
				},
				postLogin: {
					loading: false,
					loaded: false,
					error: false,
				},
			}
		case POST_LOGIN_ERROR:
			return {
				...state,
				login: {
					username: "",
					userId: 0,
					token: "",
					groups: [],
					employeId: 0,
					mustChangePassword: false,
				},
				postLogin: {
					loading: false,
					loaded: false,
					error: action.payload,
				},
			}
		case POST_LOGIN_SUCCESS:
			nextState = {
				...state,
				login: {
					username: action.payload.username,
					userId: parseInt(action.payload.user_id),
					token: action.payload.token,
					groups: action.payload.groups,
					employeId: parseInt(action.payload.employe_id),
					mustChangePassword: action.payload.must_change_password,
				},
				postLogin: {
					loading: false,
					loaded: false,
					error: false,
				},
			}
			authStorage.setUser(action.payload.username)
			authStorage.setUserId(parseInt(action.payload.user_id))
			authStorage.setToken(action.payload.token)
			authStorage.setGroups(action.payload.groups)
			authStorage.setEmployeId(parseInt(action.payload.employe_id))
			authStorage.setMustChangePassword(action.payload.must_change_password)
			return nextState
		case CLEAR_MUST_CHANGE:
			authStorage.setMustChangePassword(false)
			return {
				...state,
				login: { ...state.login, mustChangePassword: false },
			}
		case "SET_DEP_PAID":
			nextState = {
				...state,
				depPaid: action.value,
			}
			return nextState
		case "SET_SHOULD_DISCONNECT":
			return {
				...state,
				shouldDisconnect: action.value,
			}
		default:
			return state
	}
}

export default setNav
